import React, { useState, useEffect, useMemo } from 'react';
import i18n from "i18n-react";
import { DescriptionConfig, DescriptionGIE, NewGIE } from './DescriptionConfig';
import PropTypes from 'prop-types';

const MultipleSelectedOptionTemplate = ({ array, det, onSelectionChange }) => {

    const staticInitialValue = useMemo(() => {
        const val = det?.value || array?.detail?.[0]?.value || "";
        return val ? val.split(",") : [];
    }, [array?.key, det?.id]);

    const availableOptions = array?.companySettingTypeValue
        ? array.companySettingTypeValue.split(",")
        : [];

    const [selectedValues, setSelectedValues] = useState(staticInitialValue);

    useEffect(() => {
        setSelectedValues(staticInitialValue);
    }, [staticInitialValue]);

    const handleCheckboxChange = (val) => {
        const updated = selectedValues.includes(val)
            ? selectedValues.filter(item => item !== val)
            : [...selectedValues, val];

        setSelectedValues(updated);

        if (onSelectionChange) {
            onSelectionChange(updated.length > 0 ? updated.join(",") : null);
        }
    };

    const hasError = selectedValues.length === 0;

    return (
        <div className='col-12'>
            <DescriptionConfig keyValue={array?.key} />

            <div className='form-group row my-3'>
                <div className='col-sm-3'>
                    <b>{i18n.translate("current_value")}: </b>
                </div>
                <div className='col-sm-9'>
                    {/* Mostramos el valor inicial estático */}
                    <span className="text-muted">
                        {staticInitialValue.length > 0
                            ? staticInitialValue.map(v => i18n.translate(`${array?.key}_${v}`)).join(", ")
                            : "---"}
                    </span>
                </div>
            </div>

            {array?.update !== false ? (
                <DescriptionGIE type={det?.type || array?.detail?.[0]?.type || 0} />
            ) : (
                <NewGIE />
            )}

            <div className='form-group row mt-3'>
                <div className='col-sm-3'>
                    <b>{i18n.translate("new_value")}: </b>
                </div>
                <div className='col-sm-9'>
                    <div className={`card p-3 ${hasError ? 'border-danger' : 'bg-light'}`}>
                        {availableOptions.map((option) => (
                            <div key={option} className="form-check mb-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`check-${array?.key}-${option}`}
                                    checked={selectedValues.includes(option)}
                                    onChange={() => handleCheckboxChange(option)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <label
                                    className="form-check-label cursor-pointer"
                                    htmlFor={`check-${array?.key}-${option}`}
                                >
                                    {i18n.translate(`${array?.key}_${option}`)}
                                </label>
                            </div>
                        ))}

                        {hasError && (
                            <div className="mt-2 text-danger animate__animated animate__fadeIn">
                                <small>
                                    <strong>{i18n.translate("at_least_one_option_required")}</strong>
                                </small>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

MultipleSelectedOptionTemplate.propTypes = {
    array: PropTypes.shape({
        key: PropTypes.string,
        companySettingTypeValue: PropTypes.string,
        update: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            })
        )
    }),
    det: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        value: PropTypes.string,
        type: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    onSelectionChange: PropTypes.func
};
MultipleSelectedOptionTemplate.defaultProps = {
    array: {
        key: "",
        companySettingTypeValue: "",
        update: true,
        detail: [{ value: "", type: 0 }]
    },
    det: {
        id: "",
        value: "",
        type: 0
    },
    onSelectionChange: () => { }
};

export default MultipleSelectedOptionTemplate;